import React from "react";
import Section from "../../Blog/BlogMasonary/Section";
import MasonaryContent from "../../Blog/BlogMasonary/MasonaryContent";

const BlogMasonary = () => {
  document.title =
    "Avanza | Blog";

  return (
    <React.Fragment>
      <Section />
      <MasonaryContent />
    </React.Fragment>
  );
};

export default BlogMasonary;
